import axios from '../../../config/axiosConfig';
import { AdminReportsResponse, AdminReport } from '../../../shared';
import { ErrorResponse } from '../../../shared';

export const fetchReports = async(abortController: AbortController): Promise<AdminReportsResponse|ErrorResponse> => {
  const body = {
    adminId: -1,
    studentId: ''
  };
  const response = await axios.post<AdminReport[]>('api/report/reports', body, {signal: abortController.signal})
    .then(res => res.data)
    .then((reports):AdminReportsResponse => ({
      __typename: 'AdminReportsResponse',
      reports
    }))
    .catch((errMsg): ErrorResponse => ({
      __typename: 'ErrorResponse',
      errMsg
    }));
  return response;
};